<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Job Deploy Priority Configuration</h1>
    </div>
    <div class="flex-shrink-1 pt-2">
      <button
        pButton
        style="width: 250px"
        (click)="recalculateAllGradings()"
        [label]="calculatingGradings ? 'Calculating...' : 'Recalculate Gradings'"
      ></button>
      <button
        pButton
        style="width: 250px"
        (click)="recalculateAllSensitivityScores()"
        [label]="calculatingSensitivityScores ? 'Calculating...' : 'Recalculate Sensitivity Scores'"
      ></button>
    </div>
  </div>
</div>
<div>
  <p-tabView class="tab-padding no-widget-border">
    <p-tabPanel header="Customer Sensitivity" [cache]="false">
      <customer-sensitivity-scores></customer-sensitivity-scores>
    </p-tabPanel>
    <p-tabPanel header="Sensitivity Weightings" [cache]="false">
      <ng-template pTemplate="content">
        <deploy-sensitivity-weightings></deploy-sensitivity-weightings>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Grades" [cache]="false">
      <ng-template pTemplate="content">
        <deploy-priority-gradings></deploy-priority-gradings>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Grading Rules" [cache]="false">
      <ng-template pTemplate="content">
        <deploy-priority-grading-rules></deploy-priority-grading-rules>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
